import { render, staticRenderFns } from "./WiringsRegister.vue?vue&type=template&id=8ad2faea"
import script from "./WiringsRegister.vue?vue&type=script&lang=js"
export * from "./WiringsRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports